import React from "react";
import { motion } from "framer-motion";

const TableSkeleton = ({ rows = 5, columns = 4, animation = "wave" }) => {
  const getAnimationProps = () => {
    if (animation === false) return {};

    if (animation === "wave") {
      return {
        initial: { backgroundPosition: "200% 0" },
        animate: { backgroundPosition: "-200% 0" },
        transition: {
          repeat: Infinity,
          duration: 3,
          ease: "linear",
        },
        style: {
          backgroundImage:
            "linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)",
          backgroundSize: "200% 100%",
        },
      };
    }

    return {
      animate: { opacity: [0.5, 1, 0.5] },
      transition: {
        repeat: Infinity,
        duration: 2,
        ease: "linear",
      },
    };
  };

  return (
    <div className="w-full space-y-3">
      {/* Header */}
      <div
        className="grid gap-3"
        style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
      >
        {[...Array(columns)].map((_, i) => (
          <motion.div
            key={`header-${i}`}
            className="h-10 bg-gray-300 rounded"
            {...getAnimationProps()}
          />
        ))}
      </div>

      {/* Rows */}
      {[...Array(rows)].map((_, rowIndex) => (
        <div
          key={rowIndex}
          className="grid gap-3"
          style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
        >
          {[...Array(columns)].map((_, colIndex) => (
            <motion.div
              key={colIndex}
              className={`h-8 rounded ${
                rowIndex % 2 === 0 ? "bg-gray-200" : "bg-gray-100"
              }`}
              style={{
                width: colIndex === 0 ? "70%" : "100%",
              }}
              {...getAnimationProps()}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default TableSkeleton;
